import {
  ChatServiceQrImg,
  ChatServiceQrImgTfsoftware,
  ChatServiceQrImgWhatsapp,
} from 'bizComponents/ChatServiceQrImg';
import { isQuickChat, isTfsoftware, isSiteGiant, isMasterOnline } from 'productLine';

const Empty = () => null;

const ContactContent =
  isSiteGiant || isMasterOnline
    ? Empty
    : isQuickChat
    ? ChatServiceQrImgWhatsapp
    : isTfsoftware
    ? ChatServiceQrImgTfsoftware
    : ChatServiceQrImg;

export default ContactContent;
